import React from 'react';
import Navbar from '../../components/Navbar';
import PatientCreate from '../../components/Patient/PatientCreate';
import './PatientCreatePage.css';

const PatientCreatePage = () => {
  return (
    <div className="patient-create-page">
      <Navbar />
      <div className="create-page-container">
        <PatientCreate />
      </div>
    </div>
  );
};

export default PatientCreatePage;
